<div class="col">
  <div class="row">
    <div class="col-12">
      <div style="display:none">
        <div id="section">
          <div class="wrapper">
            <table class="full-width ">

              <tr style="vertical-align:top;">

                <td colspan="6" class="reportTitle_ar">
                  {{translate.currentLang
                  == 'ar' ?
                  ' المواعيد المستقبلية للمريض' :' Print future appointments'}}

                </td>
              </tr>
              <tr style="vertical-align:top;">
                <td colspan="6" class="tr-as-line"></td>
              </tr>
              <tr>
                <td class="groupHeaderLabelCell_ar under-line-cell"><strong>{{'MRN' |
                    translate}}</strong></td>
                <td class="groupHeaderDataCell_ar under-line-cell">{{patData.patCode}}</td>
                <td class="groupHeaderLabelCell_ar under-line-cell"><strong>{{'PATNAMEAR' |
                    translate}}</strong></td>
                <td class="groupHeaderDataCell_ar under-line-cell">
                  {{translate.currentLang == 'ar' ? patData.fullnameAr : patData.fullnameEn}}
                </td>
              </tr>

            </table>
            <table class="full-width">
              <tr>
                <td class="groupHeaderLevel1_ar">{{'VISITNUMBER' | translate}}</td>
                <td class="groupHeaderLevel1_ar">{{'VisitDate' | translate}}</td>
              </tr>
              <tbody>
                <tr *ngFor="let obj of futurePatDataReservationList">
                  <td class="detailBand_ar">{{obj.visitSerial}}</td>

                  <td class="detailBand_ar">{{obj.expectedStartTime | date:'dd-MM-yyyy hh:mm aa' }}
                  </td>


                </tr>
                <tr>
                  <td colspan="9"></td>
                </tr>
              </tbody>
            </table>

          </div>
          <!-- <div class="footer">
                      <table class="full-width">
                          <tr>
                              <td class="groupHeaderDataCell_ar"><strong>Phone:</strong>01022833775</td>
                              <td class="groupHeaderDataCell_ar"><strong>Email:</strong> <a
                                      href="web@bee.com">web@BEE.com</a>
                              </td>
                          </tr>
                      </table>
                  </div> -->
        </div>
      </div>
      <app-print-page #printComponent section="section"></app-print-page>
    </div>
  </div>
</div>